export const TRACKCONDITION = {
  UNKNOWN_CONDITION: null,
  FIRM1: 'Fast',
  FIRM2: 'Fast',
  GOOD3: 'Good',
  GOOD4: 'Good',
  SOFT5: 'Dead',
  SOFT6: 'Slow',
  SOFT7: 'Slow',
  HEAVY8: 'Heavy',
  HEAVY9: 'Heavy',
  HEAVY10: 'Heavy',
  DEAD: 'Dead',
  DIRT: 'Dead',
  EASY: 'Dead',
  FAIR: 'Good',
  FAST: 'Fast',
  GOOD: 'Good',
  HEAVY: 'Heavy',
  SAND: 'Slow',
  SLOW: 'Slow',
  VERY_HEAVY: 'Heavy',
  FIRM: 'Good',
  SOFT: 'Slow'
}

export const RACESTATUS = {
  UNKNOWN: true,
  OPEN: 'Open',
  CLOSED: 'Closed',
  INTERIM: 'Interim/Paying',
  FINAL: 'Interim/Paying',
  IN_PROGRESS: 'Closed',
  BEHIND_GATES: 'Open',
  PAST_POST: 'Closed',
  ABANDONED: 'Abandoned',
  PROTEST: 'Closed'
}

export const ROLEACTIONCODE = {
  READ: 0,
  FULL: 1
}

export const ROLEACTIONS = [
  { name: 'Read Only', value: ROLEACTIONCODE.READ },
  { name: 'Full Control', value: ROLEACTIONCODE.FULL }
]

export const RESOURCENAMES = {
  GLOBAL: 'tbm-cp-all',
  API: 'tbm-cp-api',
  TERMINALS: 'tbm-cp-terminals',
  TERMINALS_INCOMING: 'tbm-cp-terminals-incoming',
  TERMINALS_REGISTERED: 'tbm-cp-terminals-registered',
  TERMINALS_USERS: 'tbm-cp-terminals-users',
  FUTURES: 'tbm-cp-futures',
  SPORTS: 'tbm-cp-sports',
  DO:'tbm-cp-do',
  SILKS:'tbm-cp-silks',
  MANAGEMENT:'tbm-cp-management',
  GRN:'tbm-cp-grn',

}


export const RESOURCETREEBASETEMPLATE = [
  {
    uri: RESOURCENAMES.GLOBAL,
    name: 'All',  //everything inside CP
    parent: null,
    children: [
      {
        parent: RESOURCENAMES.GLOBAL,
        uri: RESOURCENAMES.API,
        name: 'API'
      },
      {
        parent: RESOURCENAMES.GLOBAL,
        uri: RESOURCENAMES.TERMINALS,
        name: 'Terminals',
        children: [
          {
            parent: RESOURCENAMES.TERMINALS,
            uri: RESOURCENAMES.TERMINALS_INCOMING,
            name: 'Incoming'
          },
          {
            parent: RESOURCENAMES.TERMINALS,
            uri: RESOURCENAMES.TERMINALS_REGISTERED,
            name: 'Registered'
          },
          {
            parent: RESOURCENAMES.TERMINALS,
            uri: RESOURCENAMES.TERMINALS_USERS,
            name: 'Users'
          }
        ]
      },
      {
        parent: RESOURCENAMES.GLOBAL,
        uri: RESOURCENAMES.FUTURES,
        name: 'Futures'
      },
      {
        parent: RESOURCENAMES.GLOBAL,
        uri: RESOURCENAMES.SPORTS,
        name: 'Sports'
      },
      {
        uri: RESOURCENAMES.DO,
        name: 'DynamicOdss'
      },
      {
        parent: RESOURCENAMES.GLOBAL,
        uri: RESOURCENAMES.SILKS,
        name: 'Silks'
      },
      {
        parent: RESOURCENAMES.GLOBAL,
        uri: RESOURCENAMES.MANAGEMENT,
        name: 'Management'
      },
      {
        parent: RESOURCENAMES.GLOBAL,
        uri: RESOURCENAMES.GRN,
        name: 'GRN'
      },
    ]
  }
]

export const VENUENAMETOCODE = {
  "MN": 'MN',
  "MONMOUTH": 'MN',
  "MONMOUTH PARK":"MN",
  "CAY":'CAY',
  "CAYMANAS":'CAY'
}